<template>
  <!-- <router-view class="parent-view-content"></router-view> -->
  <div style="margin-top: 2px;">
    <div class="wrapper" style="margin-bottom: 2px;">
      <div class="desktop-nav">
        <div class="nav-container">
          <div class="column quick-search">
            <RetailerQuickSearch
              ref="retailerQuickSearch"
              key="1"
              :is-admin="true"
            />
          </div>
          <ul class="menu-items">
            <li>
              <router-link :to="`/admin/brand/${brandId}/main`">
                <a-icon class="retailer-icon-style" type="home" />
                {{ $t("Components.Brands.Header.home") }}
              </router-link>
            </li>
            <li>
              <router-link :to="`/admin/brand/${brandId}/products`">
                <!-- <a-icon class="retailer-icon-style" type="audit" />
                {{ $t("Components.Brands.Header.catalog") }} -->
                <div class="svg-menu-icon">
                  <svg
                    width="49"
                    height="24"
                    viewBox="0 0 49 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.5 22H29.5C30.0304 22 30.5391 21.7893 30.9142 21.4142C31.2893 21.0391 31.5 20.5304 31.5 20V4C31.5 3.46957 31.2893 2.96086 30.9142 2.58579C30.5391 2.21071 30.0304 2 29.5 2H17.5C16.9696 2 16.4609 2.21071 16.0858 2.58579C15.7107 2.96086 15.5 3.46957 15.5 4V20C15.5 20.5304 15.2893 21.0391 14.9142 21.4142C14.5391 21.7893 14.0304 22 13.5 22ZM13.5 22C12.9696 22 12.4609 21.7893 12.0858 21.4142C11.7107 21.0391 11.5 20.5304 11.5 20V11C11.5 9.9 12.4 9 13.5 9H15.5"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M27.5 14H19.5"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M24.5 18H19.5"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.5 6H27.5V10H19.5V6Z"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>{{ $t("Components.Brands.Header.catalog") }}</span>
                </div>
              </router-link>
            </li>
            <li>
              <router-link
                :to="
                  `/admin/brand/${brandId}/orders?tabId=1&status=pending,confirmed&_sort-by=created_at&_order-by=PREVIOUS&_limit=50`
                "
              >
                <a-icon class="retailer-icon-style" type="line-chart" />
                {{ $t("Components.Brands.Header.orders") }}
              </router-link>
            </li>
            <li>
              <router-link :to="`/admin/brand/${brandId}/inventory`">
                <a-icon class="retailer-icon-style" type="table" />
                {{ $t("Components.Brands.Header.inventory") }}
              </router-link>
            </li>
            <li>
              <router-link :to="`/admin/brand/${brandId}/training?tab=product`">
                <!-- <a-icon class="retailer-icon-style" type="bulb" />
                Training -->
                <div class="svg-menu-icon fill">
                  <svg
                    width="70"
                    height="24"
                    viewBox="0 0 70 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M36.5 24C43.1274 24 48.5 18.6274 48.5 12C48.5 5.37258 43.1274 0 36.5 0C32.9119 0 29.6916 1.57479 27.4926 4.07092C27.7362 4.07861 28.0079 4.0863 28.308 4.094C28.88 4.10866 29.452 4.116 30.024 4.116C30.7427 4.116 31.4247 4.10866 32.07 4.094C32.7153 4.07933 33.17 4.072 33.434 4.072C35.1647 4.072 36.4553 4.39466 37.306 5.04C38.1713 5.68533 38.604 6.514 38.604 7.526C38.604 8.03933 38.4647 8.55266 38.186 9.066C37.922 9.57933 37.4893 10.0413 36.888 10.452C36.3013 10.8627 35.5313 11.1707 34.578 11.376V11.42C35.8687 11.5373 36.888 11.8013 37.636 12.212C38.3987 12.608 38.9413 13.0847 39.264 13.642C39.5867 14.1847 39.748 14.7567 39.748 15.358C39.748 16.2527 39.5133 17.0227 39.044 17.668C38.5893 18.2987 37.9293 18.7827 37.064 19.12C36.1987 19.4573 35.1573 19.626 33.94 19.626C33.6173 19.626 33.126 19.6187 32.466 19.604C31.806 19.5747 31.0067 19.56 30.068 19.56C29.4667 19.56 28.88 19.5673 28.308 19.582C27.8896 19.582 27.5261 19.5898 27.2175 19.6055C29.4183 22.2884 32.7592 24 36.5 24ZM26.9 19.2012V19.186C27.384 19.1567 27.7433 19.098 27.978 19.01C28.2273 18.922 28.3887 18.746 28.462 18.482C28.55 18.218 28.594 17.822 28.594 17.294V6.382C28.594 5.83933 28.55 5.44333 28.462 5.194C28.3887 4.93 28.2273 4.754 27.978 4.666C27.7824 4.58041 27.5001 4.5254 27.1312 4.50097C25.4848 6.55522 24.5 9.16261 24.5 12C24.5 14.702 25.393 17.1954 26.9 19.2012ZM31.872 4.864C32.0627 4.61466 32.4587 4.49 33.06 4.49C33.94 4.49 34.5707 4.76866 34.952 5.326C35.3333 5.86866 35.524 6.68266 35.524 7.768C35.524 8.39866 35.4507 8.99266 35.304 9.55C35.1573 10.0927 34.8787 10.5327 34.468 10.87C34.0573 11.1927 33.478 11.354 32.73 11.354H31.608V6.382C31.608 5.61933 31.696 5.11333 31.872 4.864ZM31.608 11.728V17.294C31.608 17.8073 31.652 18.196 31.74 18.46C31.828 18.724 31.982 18.9 32.202 18.988C32.422 19.076 32.7447 19.12 33.17 19.12C34.3727 19.12 35.238 18.79 35.766 18.13C36.3087 17.4553 36.58 16.502 36.58 15.27C36.58 14.1407 36.2867 13.268 35.7 12.652C35.128 12.036 34.1747 11.728 32.84 11.728H31.608ZM42.9 17.162C42.5773 16.8687 42.1667 16.722 41.668 16.722C41.1547 16.722 40.7367 16.8687 40.414 17.162C40.106 17.4553 39.952 17.844 39.952 18.328C39.952 18.812 40.106 19.2007 40.414 19.494C40.7367 19.7873 41.1547 19.934 41.668 19.934C42.1667 19.934 42.5773 19.7873 42.9 19.494C43.2227 19.2007 43.384 18.812 43.384 18.328C43.384 17.844 43.2227 17.4553 42.9 17.162Z"
                    />
                  </svg>
                  <span>BeautyFluent</span>
                </div>
              </router-link>
            </li>
            <li>
              <router-link :to="`/admin/brand/${brandId}/clean`">
                <!-- <img id="brandCleanPreCheck" class="retailer-icon-style" />
                {{ $t("Components.Brands.Header.preCheck") }} -->
                <div class="svg-menu-icon">
                  <svg
                    width="54"
                    height="24"
                    viewBox="0 0 54 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M37 11.08V12C36.9988 14.1564 36.3005 16.2547 35.0093 17.9818C33.7182 19.709 31.9033 20.9725 29.8354 21.5839C27.7674 22.1953 25.5573 22.1219 23.5345 21.3746C21.5117 20.6273 19.7847 19.2461 18.611 17.4371C17.4373 15.628 16.8798 13.4881 17.0217 11.3363C17.1636 9.18455 17.9972 7.13631 19.3983 5.49706C20.7994 3.85781 22.6928 2.71537 24.7962 2.24013C26.8996 1.7649 29.1003 1.98232 31.07 2.85999"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M37 4L27 14.01L24 11.01"
                      stroke="#202020"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>{{ $t("Components.Brands.Header.preCheck") }}</span>
                </div>
              </router-link>
            </li>
            <!-- <li>
              <router-link :to="`/admin/brand/${brandId}/profile`">
                <a-icon class="retailer-icon-style" type="user" />
                {{ $t("Components.Brands.Header.profile") }}
              </router-link>
            </li>
            <li>
              <router-link :to="`/admin/brand/${brandId}/settings`">
                <a-icon class="retailer-icon-style" type="setting" />
                {{ $t("Components.Brands.Header.settings") }}
              </router-link>
            </li> -->
            <!-- <li>
              <a href="#">
                <img
                  v-if="brand.logoAsset.url"
                  class="dropdown-icon-container"
                  :src="brand.logoAsset.url"
                />
                <img
                  v-if="!brand.logoAsset.url"
                  class="dropdown-icon-container"
                  :src="require('@/assets/img/default-logo-image.png')"
                />
              </a>
            </li> -->
            <li class="dropdown">
              <a href="#">
                <img
                  v-if="brand.logoAsset.url"
                  class="dropdown-icon-container"
                  :src="brand.logoAsset.url"
                />
                <img
                  v-if="!brand.logoAsset.url"
                  class="dropdown-icon-container"
                  :src="require('@/assets/img/default-logo-image.png')"
                />
              </a>
              <div class="profile-menu">
                <router-link :to="`/admin/brand/${brandId}/profile`">
                  <a-icon class="menu-icon-style" type="user" />
                  {{ $t("Components.Brands.Header.profile") }}
                </router-link>
                <router-link :to="`/admin/brand/${brandId}/settings/myAccount`">
                  <a-icon class="menu-icon-style" type="setting" />
                  {{ $t("Components.Brands.Header.settings") }}
                </router-link>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>
<script>
import RetailerQuickSearch from "@/components/brands/retailers/RetailerQuickSearch";
export default {
  components: {
    RetailerQuickSearch,
  },
  data() {
    return {
      brandId: undefined,
    };
  },
  computed: {
    brand() {
      return this.$store.getters["brand/brand"];
    },
  },
  async created() {
    this.brandId = this.$route.params.brandId;
    await this.$store.dispatch("brand/getBrand", this.brandId);
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap");
@font-face {
  font-family: "ProximaNova-Regular";
  src: url(~@/assets/fonts/ProximaNova-Regular.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SF-Pro-Display-Regular";
  src: url(~@/assets/fonts/SFProDisplay-Regular.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

/* Colors */

:root {
  --Gray-2: #fafafa;
  --Gray-3: #f5f5f5;
  --Gray-4: #e8e8e8;
  --Gray-5: #d9d9d9;
  --Gray-7: #8c8c8c;
  --Gray-8: #595959;
  --Gray-10: #000000;
  --Landing_Brand_Orange: #ff6132;
  --Landing_Green: #4a8a5d;
}

body {
  font-family: "ProximaNova-Regular";
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

/* Navigation Style */

.quick-search {
  margin-left: 5%;
  margin-right: 1%;
}

.column {
  padding: 3px 0px 3px 0px;
}

.desktop-nav {
  background: #fffaf9;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;
  font-family: "ProximaNova-Regular";
}

.desktop-nav .nav-container {
  position: relative;
  display: -webkit-flex;
  justify-content: space-between;
  max-width: 1197px;
  /*min-width: 954px;*/
  margin: auto;
  /*box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 0;*/
}

.desktop-nav .logo {
  margin-top: 13px;
  margin-bottom: 13px;
  margin-left: 126px;
}

.desktop-nav .menu-items {
  margin-top: 14px;
  margin-bottom: 5px;
  margin-right: 106px;
  display: -webkit-flex;
  list-style: none;
}

.desktop-nav .menu-items li {
  margin: 0 12px;
}

.desktop-nav .menu-items li a {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 22px;
  text-decoration: none;
  color: var(--Gray-7);
}

.desktop-nav .menu-items li img {
  display: block;
  margin: auto;
}

.inventory {
  padding: 3px 1px;
}

.catalog {
  padding: 1px 3px;
}

.payments {
  padding: 1px 1px;
}

.cpcheck {
  padding-top: 1px;
  padding-bottom: 2px;
}

.desktop-nav .menu-items .dropdown-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #8c8c8c;
  width: 36px;
  height: 36px;
  margin-top: 1px;
  margin-bottom: 0px;
}

/* Begin Dropdown */

.desktop-nav .menu-items li .profile-menu {
  display: none;
  position: absolute;
  margin-top: 48px;
  min-width: 99px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  margin-left: -28px;
  z-index: 5;
}

.desktop-nav .menu-items li .profile-menu a {
  display: block;
  padding: 4px;
  padding-left: 36px;
  font-family: "ProximaNova-Regular" !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: var(--Gray-8);
}

.desktop-nav .menu-items li .profile-menu a img {
  display: block;
  position: absolute;
  margin-left: -24px;
  margin-top: 2px;
}

.desktop-nav .menu-items li .profile-menu a:hover {
  background-color: var(--Gray-4);
}

.desktop-nav .menu-items .dropdown:hover .profile-menu {
  display: block;
}
.router-link-active {
  color: #4a8a5d !important;
}
.retailer-icon-style {
  display: block;
  font-size: 24px;
}
.menu-icon-style {
  display: block;
  position: absolute;
  margin-left: -24px;
  margin-top: 2px;
  font-size: 14px;
}
#brandCleanPreCheck {
  content: url("~@/assets/img/clean-pre-check/clean_nav_gray.svg");
}
.router-link-active > #brandCleanPreCheck {
  content: url("~@/assets/img/clean-pre-check/clean_nav_green.svg");
}
</style>
